import step1 from "./step_1.svg";
import step2 from "./step_2.svg";
import step3 from "./step_3.svg";
import step4 from "./step_4.svg";
import step2_2 from "./twoStep_2.svg";
import step3_2  from "./clinical_4.svg";
import step4_2 from "./clinical_5.svg";
import step5 from "./step_5.svg";
import step6 from "./step_6.svg";
import clinical3 from "./clinical_3.svg";
import clinical6 from "./clinical_6.svg";
import clinical7 from "./clinical_7.svg";

export const checklistIcons = {
  1: step1,
  2: step2,
  3: step3,
  4: step4,
  5: step5,
  6: step6,
};

export const twoChecklistIcons = {
  1: step1,
  2: step2_2,
  3: step3_2,
  4: step4_2,
  5: step5,
  6: step6,
};

export const clinicalIcons = {
  1: step1,
  2: step2,
  3: clinical3,
  4: step3_2,
  5: step4_2,
  6: clinical6,
  7: clinical7,
};